import { getTextWidthAndHeight } from '../../helper/getTextWidth';
import { defaultLightColor } from '../../../constants/defaultColors';

class SchematicPlot {
  constructor(props) {
    const { id, width, height, data, font, grid, unitSize, nodes, signals, unusedCompNodes, netsMaxLength, visibleSignals } = props;
    this.id = id;
    this.width = width;
    this.height = height;
    this.data = data || [];
    this.nodes = nodes || new Map()
    this.ctx = this.initCtx(id);
    this.gridWidth = unitSize;
    this.gridHeight = unitSize;
    this.unitSize = unitSize;
    this.netName = [];
    this.font = font || 12;
    this.grid = grid || false;
    this.signalColor = {};
    this.netsMaxLength = netsMaxLength || {};
    this.unusedCompNodes = unusedCompNodes || new Map()
    this.visibleSignals = visibleSignals || signals.map(item => item.name) || [];
    this.initSignalColor(signals);
    this.virtualCanvas = document.createElement("canvas");
  }

  initSignalColor = (signals) => {
    for (let signal of signals || []) {
      if (this.visibleSignals.includes(signal.name)) {
        this.signalColor[signal.name] = getSchematicSignalColor(Object.values(this.signalColor));
      }
    }
  }

  updateSignals = (signals) => {
    this.signalColor = {}
    for (let signal of signals || []) {
      this.signalColor[signal] = getSchematicSignalColor(Object.values(this.signalColor));
    }
    this.visibleSignals = [...signals];
  }

  initCtx = (id) => {
    const { width, height } = this;
    let canvas = document.getElementById(id);
    const virtualCanvas = document.createElement("canvas");
    virtualCanvas.width = width || canvas.width;
    virtualCanvas.height = height || canvas.height;
    this.virtualCanvas = virtualCanvas;
    const ctx = virtualCanvas.getContext('2d');
    ctx.lineWidth = 4;
    ctx.font = `normal ${this.font}px Arial`;
    ctx.fillStyle = '#000000';
    this.netName = [];
    this.verticals = [];
    this.dashedLines = [];
    return ctx;
  }

  clear = () => {
    const { ctx, width, height, id } = this;
    ctx && ctx.clearRect(0, 0, width, height);
    this.ctx = this.initCtx(id);
    let canvas = document.getElementById(id);
    if (canvas) {
      canvas.width = width;
    }
  }

  reset = ({ width, height }) => {
    this.clear();
    this.ctx = this.initCtx(this.id);
    this.width = width;
    this.height = height;
  }

  set = (param, value) => {
    this[param] = value;
  }

  redraw = () => {
    this.clear();
    this.draw();
  }

  draw = () => {

    this.drawBackground();

    /* this.drawGrid(); */

    this.drawPaths();

    this.drawNodes();

    this.drawToTrueCanvas();
  }

  drawToTrueCanvas = () => {
    const { id, virtualCanvas } = this;
    let canvas = document.getElementById(id);
    let ctx = canvas.getContext('2d');
    ctx.drawImage(virtualCanvas, 0, 0);
  }

  drawGrid = () => {
    const { ctx, width, height } = this;
    ctx.save();
    ctx.lineWidth = 1;
    ctx.translate(0.5, 0.5);
    ctx.beginPath();
    ctx.strokeStyle = '#dfdfdfff';

    let drawWidth = this.gridWidth;
    while (drawWidth <= width) {
      ctx.moveTo(drawWidth, 0);
      ctx.lineTo(drawWidth, height);
      ctx.stroke();
      drawWidth = Math.round(drawWidth + this.gridWidth);
    }
    ;
    let drawHeight = this.gridHeight;
    while (drawHeight <= height) {
      ctx.moveTo(0, drawHeight);
      ctx.lineTo(width, drawHeight);
      ctx.stroke();
      drawHeight = Math.round(drawHeight + this.gridHeight);
    }

    ctx.closePath();
    ctx.translate(1, 1);
  }

  drawBackground = () => {
    /*   const { ctx, width, height } = this;
      ctx.beginPath();
      ctx.fillStyle = '#ffffff';
      ctx.rect(0, 0, width, height);
      ctx.fill();
      ctx.closePath(); */
  }

  drawPaths = () => {
    const { data, ctx } = this;
    let existNets = [];
    this.dashedLines = [];
    this.verticals = [];
    this.lengths = [];
    this.netNames = [];

    for (let paths of data) {

      const { from, to, fromX, fromY, toX, toY, signal, /* pathName, */ unitLength, net, isParallel, startPinText, endPinText, showLength, showCompPinLength, isDash } = paths;

      if (!this.visibleSignals.includes(signal)) {
        continue;
      }
      const startX = fromX * this.unitSize;
      let startY = fromY * this.unitSize;
      const endX = toX * this.unitSize;
      let endY = toY * this.unitSize;
      let showStartText = true, showEndText = false;

      if ((toY !== fromY && !isParallel) || isDash) {
        //dash line
        if (fromY > toY) {
          this.dashedLines.push({
            startX: endX,
            startY,
            endX,
            endY,
            signal
          })
          endY = fromY * this.unitSize;
          showStartText = false;
          showEndText = true;
        } else {
          this.dashedLines.push({
            startX,
            startY,
            endX,
            endY,
            signal
          })
          startY = toY * this.unitSize;
        }
      }

      if (isParallel) {
        this.verticals.push({
          startX,
          startY,
          endX,
          endY,
          signal
        })
        if (showLength && Number(paths.length || 0) > 0) {
          const length = Math.round((paths.length || 0) * 100) / 100;
          ctx.font = `12px Arial`;
          ctx.lineWidth = 1
          ctx.fillStyle = `#000000`;
          const lengthX = startX + 2;
          const lengthY = endY + 25
          this.lengths.push({
            length,
            lengthX,
            lengthY
          });
        }
        continue
      }

      ctx.strokeStyle = this.signalColor[signal];
      ctx.lineWidth = 10;
      ctx.beginPath()
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
      ctx.closePath();

      if (startPinText && showStartText) {
        const { width } = getTextWidthAndHeight(startPinText, { fontSize: 14, fontWeight: '400' });

        ctx.font = `12px Arial`;
        ctx.lineWidth = 1
        ctx.fillStyle = `#000000`;
        ctx.beginPath();
        ctx.fillText(startPinText, startX - width - 2, endY + 2);
        ctx.closePath();
      }

      if (endPinText && showEndText) {

        ctx.font = `12px Arial`;
        ctx.lineWidth = 1
        ctx.fillStyle = `#000000`;
        ctx.beginPath();
        ctx.fillText(endPinText, endX + 2, startY + 2);
        ctx.closePath();
      }

      if (from === to && !showCompPinLength) {
        continue;
      }

      if (Number(paths.length || 0) > 0) {
        const length = Math.round((paths.length || 0) * 100) / 100;
        const { width: lengthWidth, height: lengthHeight } = getTextWidthAndHeight(length, { fontSize: 14, fontWeight: '500' });
        ctx.font = `12px Arial`;
        ctx.lineWidth = 1
        ctx.fillStyle = `#000000`;
        const xLengthSpacing = Math.abs(endX - startX) - lengthWidth;
        const lengthX = startX + 0.5 * (xLengthSpacing > 0 ? xLengthSpacing : 0);
        const lengthY = isParallel ? endY + lengthHeight : startY - 0.5 * lengthHeight;
        this.lengths.push({
          length,
          lengthX,
          lengthY
        });
      }

      /*     ctx.beginPath();
          ctx.fillText(length, lengthX, lengthY);
          ctx.closePath(); */

      if (existNets.includes(net) || this.netsMaxLength[net] !== unitLength) {
        continue;
      }
      const { width: nameWidth, height: nameHeight } = getTextWidthAndHeight(net, { fontSize: 14 });

      const xSpacing = Math.abs(endX - startX) - nameWidth;
      const nameX = startX + 0.5 * (xSpacing > 0 ? xSpacing : 0);
      const nameY = unitLength * this.unitSize < nameWidth ? startY - nameHeight - 5 : startY + 3;
      this.netNames.push({
        net,
        nameX,
        nameY
      });
      /*   ctx.beginPath();
        ctx.fillText(net, nameX, nameY);
        ctx.closePath(); */
      existNets.push(net);

    }

    for (let vertical of this.verticals) {
      const { startX, startY, endX, endY, signal } = vertical;
      ctx.strokeStyle = this.signalColor[signal];
      ctx.lineWidth = 3;
      ctx.beginPath()
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
      ctx.closePath();
    }

    for (let dashedLine of this.dashedLines) {
      const { startX, startY, endY, signal } = dashedLine;
      ctx.setLineDash([8, 8])
      ctx.strokeStyle = this.signalColor[signal];
      ctx.lineWidth = 3;
      ctx.beginPath()
      ctx.moveTo(startX, startY);
      ctx.lineTo(startX, endY);
      ctx.stroke();
      ctx.closePath();
      ctx.setLineDash([])
    }

    for (let netItem of this.netNames) {
      const { net, nameX, nameY } = netItem;
      ctx.font = `12px Arial`;
      ctx.lineWidth = 1
      ctx.fillStyle = `#000000`;
      ctx.beginPath();
      ctx.fillText(net, nameX, nameY);
      ctx.closePath();
    }

    for (let lengthItem of this.lengths) {
      const { length, lengthX, lengthY } = lengthItem;
      ctx.font = `12px Arial`;
      ctx.lineWidth = 1
      ctx.fillStyle = `#000000`;
      ctx.beginPath();
      ctx.fillText(length, lengthX, lengthY);
      ctx.closePath();
    }
  }

  drawNodes = () => {
    const { nodes, ctx } = this;
    for (let node of [...nodes.keys()]) {
      const { x, y, signal } = nodes.get(node);
      if (!this.visibleSignals.includes(signal)) {
        continue;
      }
      const _x = x * this.unitSize,
        _y = y * this.unitSize;
      ctx.beginPath();
      ctx.arc(_x, _y, 8, 0, Math.PI * 2);
      ctx.fillStyle = this.signalColor[signal];;
      ctx.fill();
      ctx.closePath();

      ctx.font = `12px Arial`;
      ctx.fillStyle = '#000000';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(node, _x, _y);
    }

    for (let unusedCompNode of [...this.unusedCompNodes.keys()]) {
      const { x, y, signal, name } = this.unusedCompNodes.get(unusedCompNode);
      if (!this.visibleSignals.includes(signal)) {
        continue;
      }
      const _x = x * this.unitSize,
        _y = y * this.unitSize;
      ctx.beginPath();
      ctx.arc(_x, _y, 8, 0, Math.PI * 2);
      ctx.fillStyle = this.signalColor[signal];;
      ctx.fill();
      ctx.closePath();

      ctx.font = `12px Arial`;
      ctx.fillStyle = '#000000';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(name || unusedCompNode, _x, _y - 2);
    }
  }
}

function getSchematicSignalColor(existColors) {
  let defaultIndex = existColors.length > defaultLightColor.length ? 0 : existColors.length;
  let color = defaultLightColor[defaultIndex], index = defaultIndex;

  while (existColors.includes(color)) {
    index += 1;
    if (index > defaultLightColor.length) {
      color = defaultLightColor[existColors.length];
      break;
    }
    color = defaultLightColor[defaultIndex];
  }
  return color;
}

export {
  SchematicPlot
}